<script>
	import { user } from '../stores.js';
	import router from 'page';
	import Spinner from "../components/Spinner.svelte";
	import SpinnerLock from "../components/SpinnerLock.svelte";
	import SpinnerUnlock from "../components/SpinnerUnlock.svelte";
	import SpinnerLocked from "../components/SpinnerLocked.svelte";
    import MyGuestLinks from "./MyGuestLinks.svelte";
    import MySecrets from "./MySecrets.svelte";

	user.useLocalStorage();
	
	function goShare() {
		router("/send");
	}

	function goSigned() {
		router("/request");
	}
</script>

<main class="container">
    
    <div class="intro">
        <p>SecureShare allows secure messages to be safely communicated between CareEvolution and its clients.

        <div class="alert alert-info email-note">
            <img src="/envelope-open-regular.svg" aria-label="SecureShare" alt="CareEvolution SecureShare">
            <div>Looking for a message that was sent to you? Check your email. You may have received two separate emails—one with a link to the message and one with the password to read it.</div>
        </div>
    </div>
      
    {#if $user.name}
        <div class="home-actions">
            <div class="row">
                <div class="col col-6">
                    <div class="card">
                        <div class="card-body">
                            <p>Need to send something securely?</p>

                            <input type="button" class="btn btn-primary" onclick={goShare} value="Send Message">
                        </div>
                    </div>
                </div>

                <div class="col col-6">
                    <div class="card">
                        <div class="card-body">
                            <p>Need someone to send you something securely?</p>
                            <input type="button" class="btn btn-primary" onclick={goSigned} value="Make a Request">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col col-12">
                    <div class="card">
                        <div class="card-body">
                            <h2>Sent Messages</h2>

                            <MySecrets></MySecrets>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col col-12">
                    <div class="card">
                        <div class="card-body">
                            <MyGuestLinks></MyGuestLinks>
                        </div>
                    </div>
                </div>
            </div>
        </div>         
    {/if}
</main>

<style>

    .intro {
        font-size: 24px;
        text-align: center;
        max-width: 590px;
        margin: 0 auto;
    }

    .intro p {
        margin: 1rem 0 2rem 0;
    }
      
    .email-note {
        margin: auto;
        display: block;
        font-size: 16px;
        border: 1px solid #25B4AC;
        background: #F8FEFF;
        color: #008d8e;
        display: flex;
        text-align: left;
    }

    .email-note img {
        height: 50px;
        padding-right: 1rem;
        height: 65px;
        padding: 1rem 1.25rem 1rem .5rem;
    }

    .home-actions {
        max-width: 1040px;
        margin: 0 auto;
    }

    .home-actions .col {
        text-align: center;
        padding-top: calc(var(--bs-gutter-x));
    }

    .home-actions :global(.card) {
        height: 100%;
    }

    .home-actions :global(.card-body) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>